<script lang="ts" setup>
import { i18n } from '@/i18n';
import { computed, ref } from 'vue';
import { watch } from 'vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

const props = defineProps<{
  modalState: boolean;
  selectInputIndex: number;
  targetGroupId: string;
  currentGroupName: string;
}>();

const emits = defineEmits<{
  (e: 'close'): void;
  (e: 'apply', newGroupName: string): void;
}>();

//変数
const t = i18n.t;

// const selectedGroupId = ref<string>();
const inputGroupName = ref<string>('');

watch(
  () => props.modalState,
  (newVal) => {
    if (newVal) {
      inputGroupName.value = props.currentGroupName;
    }
  }
);

const isDisabledApplyButton = computed((): boolean => {
  return inputGroupName.value === '';
});
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('保存')"
    :modal-width="764"
    :is-disabled-next-button="isDisabledApplyButton"
    @on-back="emits('close')"
    @on-next="emits('apply', inputGroupName)"
  >
    <template #title>{{ t('グループ名の編集') }}</template>
    <template #description>{{ t('編集するグループ名を選択し、新しいグループ名で保存してください。') }}</template>

    <div class="edit-group-modal-content__main-content main-content">
      <div class="main-content__container">
        <div class="main-content__title">
          {{ t('グループ名を編集') }}
        </div>
        <input v-model="inputGroupName" type="text" class="main-content__input" />
      </div>
    </div>
  </InfoModal>
</template>

<style lang="scss" scoped>
.edit-group-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
}

.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__select-input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
    padding: 7px 8px;
  }
}
</style>
